export default function currencyConversion(price, quantity, exchangeRate) {
  try {
    return ((parseFloat(price) * quantity) / exchangeRate).toFixed(2);
  } catch (e) {
    console.error(e);
    return '';
  }
}
